import React from 'react';
import Hero from './Hero';
import About from './About';
import Services from './Services';
import Technology from './Technology';
import Process from './Process';
import Contact from './Contact';

const HomePage = () => {
  return (
    <>
      <Hero />
      <About />
      <Services />
      <Technology />
      <Process />
      <Contact />
    </>
  );
};

export default HomePage;
